import { ICON__circle_solid } from '@/assets/icons_fa';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { UI_PRIMITIVE__icon_animated } from '../../../components/ui/UI_PRIMITIVE__icon_animated';

interface Props {
  class_name_button?: string;
  class_name_icon?: string;
}

export function PLACEHOLDER_BUTTON__bar({ class_name_button = '', class_name_icon = '' }: Props) {
  return (
    <div className={`flex-center size-3 ${class_name_button}`}>
      <UI_PRIMITIVE__icon_animated
        className={`size-1.5 text-bar-border !cursor-default ${class_name_icon}`}
        Icon={ICON__circle_solid}
        renderDelay={CONSTANTS_TIME__client.MS_300}
      />
    </div>
  );
}
